import { graphql, useStaticQuery } from "gatsby";
import { SiteOptions } from "../utils/optionsTypes";

export const useMenu = (location) => {
    const data = useStaticQuery(graphql`
    query {
      wpMenus {
        data {
          location
          name
          items{
              ID
              url
              title
          }
        }
      }
    }
  `).wpMenus.data;

    return data.find((item) => item.location === location);
};
